// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"c+Xxb","rc-tabs-tab-active":"BrEDK","input-suffix":"lOmos","nav-item":"JVEY1","text":"e3Fy9","buttonContainer":"fn4Iz"};